import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/house.svg'
import _imports_1 from '../../../assets/icons/user.svg'
import _imports_2 from '@/assets/images/analytics-empty-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-a3194542"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "revenue__widget" }
const _hoisted_2 = { class: "revenue_overview__content" }
const _hoisted_3 = {
  id: "revenueOverviewChart",
  class: "revenue_left__block"
}
const _hoisted_4 = {
  id: "revenueOverviewChartEmptyState",
  class: "revenue_left__block"
}
const _hoisted_5 = { class: "revenue_right__block" }
const _hoisted_6 = { class: "iknowa__revenue" }
const _hoisted_7 = { class: "top__section" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "empty-span-iknowa-revenue"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "iknowa Revenue", -1))
const _hoisted_11 = { class: "direct__revenue" }
const _hoisted_12 = { class: "top__section" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "empty-span-direct-revenue"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Direct Revenue", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "revenue_overview__footer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "custom__tag" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "Residential")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "custom__tag" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        alt: ""
      })
    ]),
    /*#__PURE__*/_createElementVNode("span", null, "Commercial")
  ])
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import AnalyticsWidgetLayout from "@/core/components/slots/AnalyticsWidgetLayout.vue";
import { ANALYTICS_STORE } from "@/store/modules/analytics";
import Highcharts from "highcharts";
import { computed, onMounted, ref, watch, onBeforeMount } from "vue";
import { useStore } from "vuex";
import CurrencyFilter from "@/filters/currency.filter";
import arrowUpIcon from "@/assets/icons/arrow-up-icon.svg";
import arrowDownIcon from "@/assets/icons/arrow-down-icon.svg";
import CommonLoader from "@/core/components/CommonLoader.vue";
import Text from "@/core/components/ui/general/Text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RevenueCardsLayout',
  setup(__props) {

const store = useStore();
const revenuePerformanceChart = ref<any>(null);
const revenuePerformanceChartEmptyState = ref<any>(null);

const revenueOverviewChart = ref<any>(null);
const revenueOverviewChartEmptyState = ref<any>(null);

const loadingRevenuePerformance = ref(false);

const revenueOverviewChartData = computed(
  () => store.getters[`${ANALYTICS_STORE}/getRevenueOverview`]
);

const revenueData = computed(
  () => store.getters[`${ANALYTICS_STORE}/getRevenueData`]
);

const hasRevenueData = computed(() => {
  const { iknowaRevenueByPropertyCategory, directRevenueByPropertyCategory } =
    revenueData.value;

  return (
    iknowaRevenueByPropertyCategory.residential > 0 ||
    iknowaRevenueByPropertyCategory.commercial > 0 ||
    directRevenueByPropertyCategory.residential > 0 ||
    directRevenueByPropertyCategory.commercial > 0
  );
});

const revenuePerformanceChartData = computed(
  () => store.getters[`${ANALYTICS_STORE}/getRevenuePerformance`]
);

const revenuePerformanceData = computed(
  () => store.getters[`${ANALYTICS_STORE}/getRevenuePerformanceData`]
);

const xAxisCategories = computed(() => {
  if (revenuePerformanceData.value) {
    if (selectedFilter.value === "last7days") {
      const range = revenuePerformanceData.value.map((data: any) => {
        return data.day;
      });

      return range;
    }
    if (selectedFilter.value === "last4weeks") {
      const range = revenuePerformanceData.value.map((data: any) => {
        return data.Week;
      });

      return range;
    }
    if (
      selectedFilter.value === "last3months" ||
      selectedFilter.value === "last12months" ||
      selectedFilter.value === "alltime"
    ) {
      const range = revenuePerformanceData.value.map((data: any) => {
        return data.month;
      });

      return range;
    }
    if (
      selectedFilter.value === "yeartodate" ||
      selectedFilter.value === "monthtodate" ||
      selectedFilter.value === "quartertodate"
    ) {
      return [revenuePerformanceData.value.dateRange];
    }
  }
  return null;
});

const yAxisIknowaRevenuePerformanceData = computed(() => {
  if (revenuePerformanceData.value) {
    if (
      selectedFilter.value === "yeartodate" ||
      selectedFilter.value === "monthtodate" ||
      selectedFilter.value === "quartertodate"
    ) {
      return [revenuePerformanceData.value.iknowa];
    } else {
      const value = revenuePerformanceData.value.map((data: any) => {
        return data.iknowa;
      });

      return value;
    }
  }
  return null;
});

const yAxisDirectRevenuePerformanceData = computed(() => {
  if (revenuePerformanceData.value) {
    if (
      selectedFilter.value === "yeartodate" ||
      selectedFilter.value === "monthtodate" ||
      selectedFilter.value === "quartertodate"
    ) {
      return [revenuePerformanceData.value.direct];
    } else {
      const value = revenuePerformanceData.value.map((data: any) => {
        return data.direct;
      });

      return value;
    }
  }
  return null;
});
// const categories = ref(["Jan", "Feb", "Mar", "Apr", "May", "Jun"]); //["Week 1", "Week 2", "Week 3", "Week 4"];
const filterItems = ref([
  { range: "Last 7 Days", value: "last7days" },
  { range: "Last 4 Weeks", value: "last4weeks" },
  { range: "Last 3 Months", value: "last3months" },
  { range: "Last 12 Months", value: "last12months" },
  { range: "Month To date", value: "monthtodate" },
  { range: "Quarter to date", value: "quartertodate" },
  { range: "Year to date", value: "yeartodate" },
  { range: "All time", value: "alltime" },
]);
const selectedFilter = ref("last3months");

const revenueOverviewChartOption = computed(() => {
  return {
    chart: {
      type: "pie",
    },

    title: {
      text: "",
    },
    tooltip: {
      useHTML: true, // Enable HTML for custom formatting
      pointFormat: "<b>{point.name}</b>: £{point.y}<br/>", // Custom format
      style: {
        color: "#333333", // Tooltip text color
        fontSize: "14px",
        fontWeight: "500", // Tooltip text size
      },
    },
    plotOptions: {
      pie: {
        innerSize: "75%", // This creates the donut effect
        slicedOffset: 20,
        depth: 45,

        startAngle: -90, // Start angle to create a semi-circle
        endAngle: 90, // End angle to create a semi-circle
        dataLabels: {
          enabled: true,
          useHTML: true,
          distance: -15, // Distance from the pie slice
          formatter: function (): any {
            // Return custom HTML content
            return `<span >
                        <img src="${require(`@/assets/icons/${
                          this.point.name + ".svg"
                        }`)}" style="width: 20px; height: 20px; vertical-align: middle;" />
                    </span>`;
          },
          align: "right", // Align the label (can be 'left', 'center', 'right')
          verticalAlign: "middle",
        },
        borderRadius: 30,
      },
    },
    series: [
      {
        name: "",
        data: [
          {
            name: "Residential",
            y: revenueData.value?.iknowaRevenueByPropertyCategory.residential,
            color: "#4F55F0",
          },
          {
            name: "Commercial",
            y: revenueData.value?.iknowaRevenueByPropertyCategory.commercial,
            color: "#4F55F0",
          },
          {
            name: "Residential",
            y: revenueData.value?.directRevenueByPropertyCategory.residential,
            color: "#FFA500",
          },
          {
            name: "Commercial",
            y: revenueData.value?.directRevenueByPropertyCategory.commercial,
            color: "#FFA500",
          },
        ],
      },
    ],
    subtitle: {
      text: `<div><p>Total revenue</p><h5>${CurrencyFilter.formatToCurrency(
        revenueData.value?.totalRevenue.toLocaleString()
      )}</h5><span class='revenue_count'>${
        revenueData.value?.iknowaPercentage +
          revenueData.value?.directPercentage >
        0
          ? `<img src="${arrowUpIcon}" />`
          : revenueData.value?.iknowaPercentage +
              revenueData.value?.directPercentage <
            0
          ? `<img src="${arrowDownIcon}" />`
          : "" // No image if the percentage is 0
      } ${
        revenueData.value?.iknowaPercentage +
        revenueData.value?.directPercentage
      }% from last month</span></div>`,
      useHTML: true,
      verticalAlign: "middle",
      align: "center",
    },
  };
});

const revenueOverviewChartOptionEmptyState = computed(() => {
  return {
    chart: {
      type: "pie",
    },

    title: {
      text: "",
    },
    tooltip: {
      useHTML: true, // Enable HTML for custom formatting
      pointFormat: "<b>{point.name}</b>: £0<br/>", // Custom format
      style: {
        color: "#333333", // Tooltip text color
        fontSize: "14px",
        fontWeight: "500", // Tooltip text size
      },
    },
    plotOptions: {
      pie: {
        innerSize: "75%", // This creates the donut effect
        slicedOffset: 20,
        depth: 45,

        startAngle: -90, // Start angle to create a semi-circle
        endAngle: 90, // End angle to create a semi-circle
        dataLabels: {
          enabled: true,
          useHTML: true,
          distance: -15, // Distance from the pie slice
          formatter: function (): any {
            // Return custom HTML content
            return `<span >
                        <img src="${require(`@/assets/icons/${
                          this.point.name + ".svg"
                        }`)}" style="width: 20px; height: 20px; vertical-align: middle;" />
                    </span>`;
          },
          align: "right", // Align the label (can be 'left', 'center', 'right')
          verticalAlign: "middle",
        },
        borderRadius: 30,
      },
    },
    series: [
      {
        name: "",
        data: [
          {
            name: "Commercial",
            y: 50,
            color: "#AEAEAE",
          },
          {
            name: "Residential",
            y: 50,
            color: "#5F5F5F",
          },
        ],
      },
    ],
    subtitle: {
      text: `<div><p>Total revenue</p><h5>${CurrencyFilter.formatToCurrency(
        revenueData.value?.totalRevenue.toLocaleString()
      )}</h5><span class='revenue_count'>${
        revenueData.value?.iknowaPercentage +
          revenueData.value?.directPercentage >
        0
          ? `<img src="${arrowUpIcon}" />`
          : revenueData.value?.iknowaPercentage +
              revenueData.value?.directPercentage <
            0
          ? `<img src="${arrowDownIcon}" />`
          : "" // No image if the percentage is 0
      } ${
        revenueData.value?.iknowaPercentage +
        revenueData.value?.directPercentage
      }% from last month</span></div>`,
      useHTML: true,
      verticalAlign: "middle",
      align: "center",
    },
  };
});

const revenuePerformanceChartOptions = computed(() => {
  return {
    chart: {
      type: "column",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: xAxisCategories.value,
    },
    yAxis: {
      visible: true,
      min: 0,
      title: {
        text: "",
      },
      gridLineWidth: 0,
      labels: {
        enabled: false, // Disables the yAxis labels (data points)
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color: "#000",
        },
        formatter: function () {
          return CurrencyFilter.formatToCurrency(this.total.toLocaleString()); // Format total with currency
        },
      },
    },
    tooltip: {
      headerFormat: "<b>{series.name}</b><br/>",
      pointFormat: "{series.name}: £{point.y}",
    },
    plotOptions: {
      column: {
        stacking: "normal",
        borderRadius: 5,
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name: "iknowa Revenue",
        data: yAxisIknowaRevenuePerformanceData.value,
        color: "#4F55F0", // Blue
      },
      {
        name: "Direct Revenue",
        data: yAxisDirectRevenuePerformanceData.value, // Update with your actual data
        color: "#FFA500", // Orange
      },
    ],
  };
});

const revenuePerformanceChartEmptyStateOptions = computed(() => {
  return {
    chart: {
      type: "column",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: xAxisCategories.value,
    },
    yAxis: {
      visible: true,
      min: 0,
      title: {
        text: "",
      },
      gridLineWidth: 0,
      labels: {
        enabled: false, // Disables the yAxis labels (data points)
      },
      stackLabels: {
        enabled: true,
        style: {
          fontWeight: "bold",
          color: "#000",
        },
        formatter: function () {
          return CurrencyFilter.formatToCurrency("0"); // Format total with currency
        },
      },
    },
    tooltip: {
      headerFormat: "<b>{series.name}</b><br/>",
      pointFormat: "{series.name}: £0",
    },
    plotOptions: {
      column: {
        stacking: "normal",
        borderRadius: 5,
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name: "iknowa Revenue",
        data: [5, 5, 5],
        color: "#5F5F5F", // Blue
      },
      {
        name: "Direct Revenue",
        data: [5, 5, 5], // Update with your actual data
        color: "#AEAEAE", // Orange
      },
    ],
  };
});

const updateRevenuePerformanceChart = () => {
  console.log("updateRevenuePerformanceChart");

  revenuePerformanceChart.value.xAxis[0].setCategories(xAxisCategories.value);
  revenuePerformanceChart.value.series[0].setData(
    yAxisIknowaRevenuePerformanceData.value
  );
  revenuePerformanceChart.value.series[1].setData(
    yAxisDirectRevenuePerformanceData.value
  );
};
// setTimeout(() => {
//   updateRevenuePerformanceChart();
// }, 5000);

// watch(
//   () => revenueData.value,
//   async (newValue) => {
//     if (newValue) {
//       if (hasRevenueData.value) {
//         console.log(hasRevenueData.value, "hasRevenueData watch runnedd");
//         console.log(revenueOverviewChart.value, "revenueOverviewChart.value.");
//         revenueOverviewChart.value.series[0].setData([
//           {
//             name: "Residential",
//             y: revenueData.value?.iknowaRevenueByPropertyCategory.residential,
//             color: "#4F55F0",
//           },
//           {
//             name: "Commercial",
//             y: revenueData.value?.iknowaRevenueByPropertyCategory.commercial,
//             color: "#4F55F0",
//           },
//           {
//             name: "Residential",
//             y: revenueData.value?.directRevenueByPropertyCategory.residential,
//             color: "#FFA500",
//           },
//           {
//             name: "Commercial",
//             y: revenueData.value?.directRevenueByPropertyCategory.commercial,
//             color: "#FFA500",
//           },
//         ]);
//         revenueOverviewChart.value.setSubtitle({
//           text: `<div><p>Total revenue</p><h5>${CurrencyFilter.formatToCurrency(
//             revenueData.value?.totalRevenue.toLocaleString()
//           )}</h5><span class='revenue_count'>${
//             revenueData.value?.iknowaPercentage +
//               revenueData.value?.directPercentage >
//             0
//               ? `<img src="${arrowUpIcon}" />`
//               : revenueData.value?.iknowaPercentage +
//                   revenueData.value?.directPercentage <
//                 0
//               ? `<img src="${arrowDownIcon}" />`
//               : "" // No image if the percentage is 0
//           } ${
//             revenueData.value?.iknowaPercentage +
//             revenueData.value?.directPercentage
//           }% from last month</span></div>`,
//           useHTML: true,
//           verticalAlign: "middle",
//           align: "center",
//         });
//       }
//     }
//   },

//   { immediate: true, deep: true }
// );

const fetchRevenuePerformance = async () => {
  loadingRevenuePerformance.value = true;
  let filter = "last3months"; // default date range

  if (selectedFilter.value) {
    filter = selectedFilter.value;
  }

  const params = {
    filter,
  };
  console.log("params", params);
  try {
    await store.dispatch(`${ANALYTICS_STORE}/fetchRevenuePerformance`, params);
  } catch (error) {
    console.log(error);
  } finally {
    loadingRevenuePerformance.value = false;
  }
};

watch(
  () => selectedFilter.value,
  async (newVal) => {
    if (newVal) {
      await fetchRevenuePerformance();
      await updateRevenuePerformanceChart();
    }
  },
  { immediate: true, deep: true }
);

onBeforeMount(async () => {
  await fetchRevenuePerformance();
});

onMounted(async () => {
  await fetchRevenuePerformance();
  revenuePerformanceChart.value = Highcharts.chart(
    "revenuePerformanceChart",
    revenuePerformanceChartOptions.value
  );
  // revenuePerformanceChartEmptyState.value = Highcharts.chart(
  //   "revenuePerformanceChartEmptyState",
  //   revenuePerformanceChartEmptyStateOptions.value
  // );
  // if (hasRevenueData.value) {
  revenueOverviewChart.value = Highcharts.chart(
    "revenueOverviewChart",
    revenueOverviewChartOption.value
  );
  // } else {
  revenueOverviewChartEmptyState.value = Highcharts.chart(
    "revenueOverviewChartEmptyState",
    revenueOverviewChartOptionEmptyState.value
  );
  // }
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AnalyticsWidgetLayout, {
      class: "revenue__card",
      title: "Revenue Overview",
      hideToolTip: true,
      headerIcon: "revenueOverview",
      borderBottom: true
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
            [_vShow, hasRevenueData.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
            [_vShow, !hasRevenueData.value]
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (hasRevenueData.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9)),
                _hoisted_10
              ]),
              _createElementVNode("h5", null, _toDisplayString(_unref(CurrencyFilter).formatToCurrency(
                    revenueData.value?.iknowaRevenue.toLocaleString()
                  )), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (hasRevenueData.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                  : (_openBlock(), _createElementBlock("span", _hoisted_14)),
                _hoisted_15
              ]),
              _createElementVNode("h5", null, _toDisplayString(_unref(CurrencyFilter).formatToCurrency(
                    revenueData.value?.directRevenue.toLocaleString()
                  )), 1)
            ])
          ])
        ]),
        _hoisted_16
      ]),
      _: 1
    }),
    _createVNode(AnalyticsWidgetLayout, {
      class: "revenue__card",
      title: "Revenue Performance",
      hideToolTip: true,
      headerIcon: "revenuePerformance",
      borderBottom: true,
      isHeaderAction: true
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass({ '!tw-hidden': !revenueData.value?.totalRevenue }),
          style: {"width":"100%","height":"415px"},
          id: "revenuePerformanceChart"
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["tw-w-full tw-flex tw-flex-col tw-gap-4 tw-justify-center tw-items-center tw-rounded-[16px] tw-overflow-hidden tw-min-h-[350px] tw-bg-white", { '!tw-hidden': revenueData.value?.totalRevenue }])
        }, [
          _hoisted_17,
          _createVNode(Text, {
            textWeight: "500",
            variant: "p",
            textColor: "rgba(12, 15, 74, 0.5)",
            lineHeight: "18px"
          }, {
            default: _withCtx(() => [
              _createTextVNode("No revenue data yet. Complete jobs to"),
              _hoisted_18,
              _createTextVNode(" see revenue performance.")
            ]),
            _: 1
          })
        ], 2)
      ]),
      "header-action": _withCtx(() => [
        _createVNode(_component_v_select, {
          modelValue: selectedFilter.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFilter).value = $event)),
          items: filterItems.value,
          "item-title": "range",
          "item-value": "value",
          variant: "outlined",
          placeholder: "Quarterly",
          "bg-color": "#fff",
          class: "input_field !tw-w-[140px]",
          type: "select"
        }, null, 8, ["modelValue", "items"])
      ]),
      _: 1
    })
  ]))
}
}

})